const MockData = [
    
     { 

        id: "502957",
        name: "Andhra Gunpowder",
        cloudinaryImageId: "bs9qgsy25pn07pzn6xx1",
        locality: "Shivananda Circle",
        areaName: "Seshadripuram",
        costForTwo: "₹350 for two",
        cuisines: [
          "Andhra",
          "Biryani",
          "South Indian"
        ],
     
        avgRating: 4.4,
        parentId: "10496",
        avgRatingString: "4.4",

        items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
        "Paneer Makhni Biryani - 299 per two",
        "Hyderabadi Paneer Biryani - 299 per two",
        "Egg Biryani - 249 per two",
        "Special Boneless Chicken Dum Biryani - 359 per two",
        "Boneless Kebab Biryani - 349 per two",
        "Chicken Tikka Masala Biryani - 349 per two",
        "Andhra Veg Meals For 2 - 559 per two",
        "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
        "Andhra Non-Veg Meals For 1 - 349 per two",
        "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
        "Andhra Style Chicken Biryani - 349 per two",
        "Bhai Chicken Biryani - 359 per two",
        "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
        "Fried Chicken Kebab(Boneless) - 279 per two",
        "Andhra Pepper Chicken - 299 per two",
        "Ghee Gulab Jamun (2 Pcs) - 59 per two",
        "Sweet Lassi - 65 per two",
        "Dry Fruit Lassi - 79 per two",
        "Mango Juice - 116 per two"]

        },
    
        {
            id: "281469",
            name: "Lavonne",
            cloudinaryImageId: "emlehbuwgsmryxhwzhvq",
            locality: "St. Marks Road",
            areaName: "St. Marks Road",
            costForTwo: "₹750 for two",
            cuisines: [
              "Bakery",
              "Desserts"
            ],
            avgRating: 4.6,
            parentId: "10530",
            avgRatingString: "4.6",
            totalRatingsString: "1K+",
            items:[" Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },

        {
    
            id: "5938",
            name: "Burger King",
            cloudinaryImageId: "e33e1d3ba7d6b2bb0d45e1001b731fcf",
            locality: "Tasker Town",
            areaName: "Shivaji Nagar",
            costForTwo: "₹350 for two",
            cuisines: [
                "Burgers",
                "American"
            ],
            avgRating: 4.2,
            parentId: "166",
            avgRatingString: "4.2",
            totalRatingsString: "10K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {

            id: "347868",
            name: "KFC",
            cloudinaryImageId: "f01666ac73626461d7455d9c24005cd4",
            locality: "Cunnigham road",
            areaName: "Vasanth Nagar",
            costForTwo: "₹4000 for two",
            cuisines: [
                "Burgers",
                "Biryani",
                "American",
                "Snacks",
                "Fast Food"
            ],
            avgRating: 4,
            parentId: "547",
            avgRatingString: "4",
            totalRatingsString: "1K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]

        },

        {
            id: "43836",
            name: "McDonald's",
            cloudinaryImageId: "bb7ae131544c7d37e10fc5faf76f09d6",
            locality: "MG Road",
            areaName: "Ashok Nagar",
            costForTwo: "₹400 for two",
            cuisines: [
                "Burgers",
                "Beverages",
                "Cafe",
                "Desserts"
            ],
            avgRating: 4.3,
            parentId: "630",
            avgRatingString: "4.3",
            totalRatingsString: "10K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]

        },
        {

            id: "23847",
            name: "Domino's Pizza",
            cloudinaryImageId: "fjqcvqfgqlw6h0atques",
            locality: "Rest House Road",
            areaName: "Brigade Road",
            costForTwo: "₹400 for two",
            cuisines: [
                "Pizzas",
                "Italian",
                "Pastas",
                "Desserts"
            ],
            avgRating: 4.3,
            parentId: "2456",
            avgRatingString: "4.3",
            totalRatingsString: "5K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },

        {
        
            id: "396748",
            name: "The Good Bowl",
            cloudinaryImageId: "6e04be27387483a7c00444f8e8241108",
            locality: "Residency Road",
            areaName: "Shantinagar",
            costForTwo: "₹400 for two",
            cuisines: [
                "Biryani",
                "Pastas",
                "Punjabi",
                "Desserts",
                "Beverages"
            ],
            avgRating: 4.4,
            parentId: "7918",
            avgRatingString: "4.4",
            totalRatingsString: "100K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]

        },
        {
            id: "30531",
            name: "Hotel Empire",
            cloudinaryImageId: "qltgnkyywuo5gmnpqzbm",
            locality: "Brigade Road",
            areaName: "Church Street",
            costForTwo: "₹450 for two",
            cuisines: [
              "North Indian",
              "Kebabs",
              "Biryani"
            ],
            avgRating: 4.4,
            parentId: "475",
            avgRatingString: "4.4",
            totalRatingsString: "10K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "65797",
            name: "Leon's - Burgers & Wings (Leon Grill)",
            cloudinaryImageId: "b2edbc28b7b8219d6e0a9c049ce06658",
            locality: "Koramangala",
            areaName: "Koramangala",
            costForTwo: "₹300 for two",
            cuisines: [
              "American",
              "Snacks",
              "Turkish",
              "Portuguese",
              "Continental"
            ],
            avgRating: 4.4,
            parentId: "371281",
            avgRatingString: "4.4",
            totalRatingsString: "10K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "614642",
            name: "Soul Rasa",
            cloudinaryImageId: "v9fczzlua1wnrx63fh1g",
            locality: "Akkithimanahalli",
            areaName: "Shanti Nagar",
            costForTwo: "₹400 for two",
            cuisines: [
              "Indian",
              "Healthy Food",
              "Home Food",
              "South Indian",
              "North Indian"
            ],
            avgRating: 4.6,
            parentId: "239281",
            avgRatingString: "4.6",
            totalRatingsString: "1K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "3434",
            name: "Nandhini Deluxe",
            cloudinaryImageId: "dlt4ml0id5wei4yi840b",
            locality: "St. Marks Road",
            areaName: "St Marks Road",
            costForTwo: "₹500 for two",
            cuisines: [
              "Andhra",
              "Biryani",
              "Chinese",
              "North Indian"
            ],
            avgRating: 4.3,
            parentId: "2451",
            avgRatingString: "4.3",
            totalRatingsString: "10K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "69876",
            name: "Subway",
            cloudinaryImageId: "1ace5fa65eff3e1223feb696c956b38b",
            locality: "UB City",
            areaName: "Ashok Nagar",
            costForTwo: "₹350 for two",
            cuisines: [
              "Salads",
              "Snacks",
              "Desserts",
              "Beverages"
            ],
            avgRating: 4.2,
            parentId: "2",
            avgRatingString: "4.2",
            totalRatingsString: "1K+",   
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "12808",
            name: "A2B - Adyar Ananda Bhavan",
            cloudinaryImageId: "pdod4o1em9potwsd22rs",
            locality: "Wilson Garden",
            areaName: "Shanti Nagar",
            costForTwo: "₹300 for two",
            cuisines: [
              "South Indian",
              "North Indian",
              "Sweets",
              "Chinese"
            ],
            avgRating: 4.5,
            veg: true,
            parentId: "22",
            avgRatingString: "4.5",
            totalRatingsString: "10K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "396741",
            name: "Faasos - Wraps, Rolls & Shawarma",
            cloudinaryImageId: "af33b81798b11deba338e94b7585d348",
            locality: "Residency Road",
            areaName: "Shantinagar",
            costForTwo: "₹200 for two",
            cuisines: [
              "Kebabs",
              "Fast Food",
              "Snacks",
              "American",
              "Healthy Food",
              "Desserts",
              "Beverages"
            ],
            avgRating: 4.3,
            parentId: "21809",
            avgRatingString: "4.3",
            totalRatingsString: "1K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "448116",
            name: "The Bowl Company",
            cloudinaryImageId: "bb6049fae59b8a2413a9177eb0338b49",
            locality: "Akkithimanahalli",
            areaName: "Shanti Nagar",
            costForTwo: "₹300 for two",
            cuisines: [
              "Pan-Asian",
              "Continental",
              "North Indian",
              "Desserts",
              "American",
              "Asian",
              "Beverages"
            ],
            avgRating: 4.5,
            parentId: "4317",
            avgRatingString: "4.5",
            totalRatingsString: "5K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "16073",
            name: "California Burrito",
            cloudinaryImageId: "27238ee4292d42c7b705f2ce8671ff80",
            locality: "Malleshwaram",
            areaName: "Malleshwaram",
            costForTwo: "₹250 for two",
            cuisines: [
              "Mexican",
              "American",
              "Salads",
              "Continental",
              "Keto",
              "Healthy Food"
            ],
            avgRating: 4.7,
            parentId: "1252",
            avgRatingString: "4.7",
            totalRatingsString: "10K+",
            items:["Slow Churn Mango Ice Cream 500 ML - 375 per two",
              "Slow Churn Strawberry Ice Cream 500 ML - 375 per two",
              "Slow Churn Guava Ice Cream 500 ML - 375 per two",
              "Slow Churn Chikoo Ice Cream 500 ML - 375 per two",
              "Slow Churn Jamun Ice Cream 500 ML - 375 per two",
              "Hazelnut Chocolate Ice Cream 500ml - 325 per two",
              "Choco Brownie Fudge Cup 100ml - 80 per two",
              "Divine Chocolate Chocochip Cup 100ml - 80 per two",
              "Cadbury Crackle 700ml - 379 per two",
              "Choco Brownie Fudge 700ml - 319 per two",
              "Oreo & Cream 700ml - 299 per two",
              "Divine Chocolate Sensation 700ml - 259 per two",
              "Fruit & Nut 700ml - 259 per two",
              "Gulab Jamun Ice cream 500ml - 275 per two",
              "Butterscotch 700ml - 180 per two",
              "Alphonso Mango 700ml - 180 per two",
              "Vanilla 700ml - 150 per two",
              "Magnum Almond Ice Cream 80ml - 99 per two",
              "Magnum Brownie Icecream 80ml - 99 per two",
              "Magnum Chocolate Truffle Ice Cream 80ml - 99 per two"]
        },
        {
            id: "363507",
            name: "Kwality Walls Frozen Dessert and Ice Cream Shop",
            cloudinaryImageId: "bavma5ly3xyktmkgpi1c",
            locality: "2nd Stage",
            areaName: "Indiranagar",
            costForTwo: "₹300 for two",
            cuisines: [
              "Desserts",
              "Ice Cream",
              "Ice Cream Cakes"
            ],
            avgRating: 4.6,
            veg: true,
            parentId: "582",
            avgRatingString: "4.6",
            totalRatingsString: "100+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "29784",
            name: "CakeZone",
            cloudinaryImageId: "63970c0e51adaacf3abd27858df8fee8",
            locality: "Hoysala Nagar",
            areaName: "Indira Nagar",
            costForTwo: "₹200 for two",
            cuisines: [
              "Bakery",
              "Desserts",
              "Sweets",
              "Ice Cream"
            ],
            avgRating: 4.4,
            parentId: "7003",
            avgRatingString: "4.4",
            totalRatingsString: "10K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "124178",
            name: "Starbucks Coffee",
            cloudinaryImageId: "258fe8a3577877fbfe064095ed1d9dc3",
            locality: "Ashok Nagar",
            areaName: "Lavelle Road",
            costForTwo: "₹400 for two",
            cuisines: [
              "Beverages",
              "Cafe",
              "Snacks",
              "Desserts",
              "Bakery",
              "Ice Cream"
            ],
            avgRating: 4.3,
            parentId: "195515",
            avgRatingString: "4.3",
            totalRatingsString: "1K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        },
        {
            id: "29063",
            name: "Misu",
            cloudinaryImageId: "lx0tpfgsbqygafwh30wh",
            locality: "St. Marks Road",
            areaName: "St. Marks Road",
            costForTwo: "₹1300 for two",
            cuisines: [
              "Asian",
              "Chinese",
              "Vietnamese",
              "Malaysian",
              "Sushi",
              "Singaporean",
              "Desserts"
            ],
            avgRating: 4.4,
            parentId: "7415",
            avgRatingString: "4.4",
            totalRatingsString: "5K+",
            items:["Butter Paneer Biryani Family Pack (serves 3-4) - 899 per two",
            "Paneer Makhni Biryani - 299 per two",
            "Hyderabadi Paneer Biryani - 299 per two",
            "Egg Biryani - 249 per two",
            "Special Boneless Chicken Dum Biryani - 359 per two",
            "Boneless Kebab Biryani - 349 per two",
            "Chicken Tikka Masala Biryani - 349 per two",
            "Andhra Veg Meals For 2 - 559 per two",
            "Andhra Veg Carrier Meals- (for 3-4) - 739 per two",
            "Andhra Non-Veg Meals For 1 - 349 per two",
            "Andhra Non-Veg Carrier Meals (for 3-4) - 939 per two",
            "Andhra Style Chicken Biryani - 349 per two",
            "Bhai Chicken Biryani - 359 per two",
            "Bhai Chicken Biryani and Chicken Kebab Combo - 499 per two",
            "Fried Chicken Kebab(Boneless) - 279 per two",
            "Andhra Pepper Chicken - 299 per two",
            "Ghee Gulab Jamun (2 Pcs) - 59 per two",
            "Sweet Lassi - 65 per two",
            "Dry Fruit Lassi - 79 per two",
            "Mango Juice - 116 per two"]
        }

    ]




export default MockData;